/* ============================================================================
   OATH JEWELRY — Mega-menu controller (Handoff B)
   Replaces the inline scripts in header-mega-menu.liquid and
   header-mega-menu-mobile.liquid. Load once, deferred, from theme.liquid:
     <script src="{{ 'oath-mega-menu.js' | asset_url }}" defer></script>

   Model: each top-level item is a real category <a> link plus an adjacent
   <button class="mega-toggle" aria-expanded aria-controls>. The button opens/
   closes the panel; the link always navigates. Accessible by click + keyboard.

   Desktop: toggles .active on the closest .site-header__nav.mega-menu
            (existing CSS shows/hides .mega-menu__list from that state).
   Mobile:  toggles .active on the .mega-menu__list itself (slide-in panel),
            with a Back button to close.
   ========================================================================== */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") { fn(); }
    else { document.addEventListener("DOMContentLoaded", fn); }
  }

  ready(function () {
    var DESKTOP = ".site-header__nav.mega-menu";
    var accNav = document.getElementById("AccessibleNav");

    function closeAllDesktop() {
      if (!accNav) return;
      accNav.querySelectorAll(DESKTOP + ".active").forEach(function (nav) {
        nav.classList.remove("active");
        var btn = nav.querySelector(".main-title .mega-toggle");
        if (btn) btn.setAttribute("aria-expanded", "false");
      });
    }

    function toggleDesktop(btn) {
      var nav = btn.closest(DESKTOP);
      if (!nav) return;
      var willOpen = !nav.classList.contains("active");
      closeAllDesktop();
      if (willOpen) {
        nav.classList.add("active");
        btn.setAttribute("aria-expanded", "true");
      }
    }

    function toggleMobile(btn) {
      var nav = btn.closest(DESKTOP);
      if (!nav) return;
      var list = nav.querySelector(".mega-menu__list");
      if (!list) return;
      var willOpen = !list.classList.contains("active");
      list.classList.toggle("active", willOpen);
      btn.setAttribute("aria-expanded", String(willOpen));
      if (willOpen) {
        var first = list.querySelector("a, button");
        if (first) first.focus();
      }
    }

    // Top-level disclosure buttons (desktop + mobile share the class)
    document.querySelectorAll(".mega-toggle").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (btn.closest(".mobile-nav-wrapper")) { toggleMobile(btn); }
        else { toggleDesktop(btn); }
      });
    });

    // Mobile "Back" buttons close the active slide panel and restore focus
    document.querySelectorAll(".mobile-nav-wrapper .back_button_btn").forEach(function (back) {
      back.addEventListener("click", function () {
        var list = back.closest(".mega-menu__list");
        if (!list) return;
        list.classList.remove("active");
        var nav = list.closest(DESKTOP);
        var btn = nav && nav.querySelector(".main-title .mega-toggle");
        if (btn) { btn.setAttribute("aria-expanded", "false"); btn.focus(); }
      });
    });

    // Escape closes the open desktop panel and returns focus to its trigger
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !accNav) return;
      var open = accNav.querySelector(DESKTOP + ".active");
      if (!open) return;
      open.classList.remove("active");
      var btn = open.querySelector(".main-title .mega-toggle");
      if (btn) { btn.setAttribute("aria-expanded", "false"); btn.focus(); }
    });

    // Click outside the nav closes any open desktop panel
    document.addEventListener("click", function (e) {
      if (!e.target.closest(DESKTOP)) closeAllDesktop();
    });

    // Moving focus out of the desktop nav (e.g. tabbing past it) closes it
    if (accNav) {
      accNav.addEventListener("focusout", function (e) {
        if (!accNav.contains(e.relatedTarget)) closeAllDesktop();
      });
    }
  });
})();
